import { DEIDENTIFY_REQUEST, DEIDENTIFY_SUCCESS, DEIDENTIFY_ERROR, DEIDENTIFY_RESET } from '../reducers/deIdentifyReducer';

import config from '../config';
import axios from 'axios';
import { getUserToken } from '../utils/helper';

export const deIdentifyApi = (params) => {
    return async (dispatch) => {
        dispatch({ type: DEIDENTIFY_REQUEST });
        try {
            const apiUrl = `${config.api.base_url}/coverage/deidentify`; 
            
            const response = await axios.post(
                apiUrl,
                params,
                {
                    headers: {
                        'Content-type': 'application/json; charset=UTF-8',
                        Authorization: 'Bearer ' + getUserToken(),
                    },
                }
            );
            
            if (response && response.data.status === 1) {
                dispatch({
                    type: DEIDENTIFY_SUCCESS,
                    payload: response.data.data,
                });
            } else {
                dispatch({
                    type: DEIDENTIFY_ERROR,
                    payload: response.data.message || 'De-identification failed',
                });
            }
        } catch (error) {
            console.error('De-identify API error:', error);
            console.error('Error response:', error.response); 
            dispatch({
                type: DEIDENTIFY_ERROR,
                payload: error.message || 'De-identification failed',
            });
        }
    };
};

export const deIdentifyReset = () => ({
    type: DEIDENTIFY_RESET,
}); 